import { useContext, useEffect, useState } from "react";
import { FormContext } from "../../../context/FormContext";

const OPTIONS = [
  { id: "amateur", label: "Amateur Poster - $10/hr", value: 10 },
  { id: "hustler", label: "Side Hustler - $30/hr", value: 30 },
  { id: "dayjob", label: "Instagram Is My Day Job - $50/hr", value: 50 },
  { id: "influencer", label: "Big Time Influencer - $100/hr", value: 100 },
];

function ValueForm() {

  const { formData, updateForm } = useContext(FormContext);

  const [local, setLocal] = useState({
    valueType: formData.valueType?.toString() ?? "",
    postCount: formData.postCount?.toString() ?? "",
    minsPerPost: formData.minsPerPost?.toString() ?? "",
  });

  const POST_ESTIMATION = 1.626;   // multiplier
  const RPP = '0.50';              // $ per post

  const MAX_POSTS = 40000000;    // cap posts at 40M
  const MAX_MINS = 525600;       // cap time ~1 year

  const fmtInt = (n) =>
    new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);

  const fmtCurrency = (n) =>
    new Intl.NumberFormat(undefined, { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n);

  useEffect(() => {
    const ctxVal = Number(formData?.postCount ?? 0);
    // only update if different to avoid cursor jumps while typing
    if (!Number.isNaN(ctxVal) && ctxVal !== local.postCount) {
      setLocal(p => ({ ...p, postCount: ctxVal }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.postCount]);

  useEffect(() => {
    const ctxVal = Number(formData?.minsPerPost ?? 0);
    // only update if different to avoid cursor jumps while typing
    if (!Number.isNaN(ctxVal) && ctxVal !== local.minsPerPost) {
      setLocal(p => ({ ...p, minsPerPost: ctxVal }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.minsPerPost]);


  // derived values
  const posts = Number(local.postCount) || 0;
  const mins = Number(local.minsPerPost) || 0;
  const value = Number(local.valueType) || 0;
  
  const estimatedPosts = posts * POST_ESTIMATION;
  const revenue =  ( estimatedPosts * (mins /60 * value));


  const handleSelect = (opt) => {
    setLocal({ valueType: String(opt.value), postCount: formData.postCount?.toString() ?? "", minsPerPost: formData.minsPerPost?.toString() ?? "" });
    updateForm?.({ valueType: opt.value });
  };

  return (
    <>
      <div className="contents-main">
        <h1 style={{ marginBottom: 8 }}>What's your time worth?</h1>

        <div>
          <p>How do you value your time per hour?</p>

          <div style={{ display: "grid", gap: 12 }}>
            {OPTIONS.map((opt) => {
              const isActive = local.valueType == opt.value;
              return (
                <label
                  key={opt.id}

                  role="radio"
                  style={{
                    userSelect: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: 12,
                    border: "1px solid",
                    borderColor: isActive ? "#1a73e8" : "#e0e0e0",
                    background: isActive ? "#e8f1ff" : "#ffffff",
                    color: "#1f2937",
                    transition: "background 120ms, border-color 120ms",
                  }}
                >
                  {/* visually hidden native radio for accessibility */}
                  <input
                    type="radio"
                    name="ratePerHour"
                    value={opt.value}
                    checked={isActive}
                    onChange={() => handleSelect(opt)}
                    style={{ opacity: 0, pointerEvents: "none", display: 'none' }}
                  />
                  {opt.label}
                </label>
              );
            })}
          </div>

        </div>
      </div>

      <div className="contents-footer">
        <p className="footer-label">Your Creative Labour Value</p>
        <p className="footer-value">{revenue.toLocaleString('en-US', { style: 'currency', currency: 'USD'})}</p>
      </div>
    </>
  );
}

export default ValueForm;
